<template>
  <b-card class="report-wrapper">

    <div class="filters">
      <label for="year">Yıl:</label>

      <b-form-select
        id="year"
        v-model="selectedYear"
        :options="years"
        @change="getReport"
      />
    </div>

    <div v-if="loading" class="loading">
      Yükleniyor...
    </div>

    <div v-else-if="error" class="error">
      {{ error }}
    </div>

    <div v-else-if="tableItems.length" class="report-result">

      <h3>
        {{ selectedYear }} Events Kullanım Raporu
      </h3>

      <b-table
        class="position-relative report-table"
        responsive
        :items="tableItems"
        :fields="tableFields"
        :tbody-tr-class="rowClass"
        show-empty
        empty-text="Seçilen yıl için veri bulunamadı"
      >

        <!-- DOMAIN -->
        <template #cell(domain)="data">
          <span v-if="data.item.showCustomer">
            {{ data.item.domain }}
          </span>
        </template>

        <!-- MÜŞTERİ -->
        <template #cell(name)="data">
          <span v-if="data.item.showCustomer">
            {{ data.item.name }}
          </span>
        </template>

      </b-table>

    </div>

    <div v-else class="no-data">
      Seçilen yıl için veri bulunamadı.
    </div>

  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BFormSelect,
} from "bootstrap-vue";

export default {
  name: "CustomersEventsUsed",

  components: {
    BCard,
    BTable,
    BFormSelect,
  },

  data() {
    const now = new Date();

    return {
      selectedYear: now.getFullYear(),

      years: Array.from(
        { length: 5 },
        (_, i) => now.getFullYear() - i
      ),

      monthNames: [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık"
      ],

      reportData: [],

      loading: false,

      error: null,
    };
  },

  computed: {

    /*
     * ---------------------------------------------------------
     * MEVCUT YILDA KAÇ AY GÖSTERİLECEK
     * ---------------------------------------------------------
     */
    maxMonth() {
      const now = new Date();

      return Number(this.selectedYear) === now.getFullYear()
        ? now.getMonth() + 1
        : 12;
    },

    /*
     * ---------------------------------------------------------
     * TÜM MÜŞTERİLERDE BULUNAN TYPE'LAR
     * ---------------------------------------------------------
     *
     * Her müşterinin kendi type'ı olabilir.
     *
     * Örneğin:
     *
     * Firma A:
     * influencer, story, bio
     *
     * Firma B:
     * influencer, sms, email
     *
     * Sonuç:
     *
     * influencer, story, bio, sms, email
     *
     */
    allTypes() {
      const types = new Map();

      this.reportData.forEach(customer => {

        (customer.types || []).forEach(type => {

          if (!types.has(type.key)) {
            types.set(type.key, type);
          }

        });

      });

      return Array.from(types.values());
    },

    /*
     * ---------------------------------------------------------
     * TABLO KOLONLARI
     * ---------------------------------------------------------
     */
    tableFields() {

      const fields = [
        {
          key: "domain",
          label: "Domain"
        },
        {
          key: "name",
          label: "Müşteri"
        },
        {
          key: "period",
          label: "Dönem"
        }
      ];

      /*
       * API'den gelen type'lara göre kolon oluştur
       */
      this.allTypes.forEach(type => {

        fields.push({
          key: type.key,
          label: type.name,
          class: "text-right"
        });

      });

      return fields;
    },

    /*
     * ---------------------------------------------------------
     * TABLO SATIRLARI
     * ---------------------------------------------------------
     */
    tableItems() {

      const items = [];

      this.reportData.forEach(customer => {

        /*
         * Bu müşterinin sahip olduğu type key'leri
         *
         * Örneğin:
         *
         * ["influencer", "story", "bio"]
         */
        const customerTypeKeys = new Set(
          (customer.types || []).map(type => type.key)
        );

        /*
         * -----------------------------------------------------
         * AYLIK SATIRLAR
         * -----------------------------------------------------
         */
        for (let m = 1; m <= this.maxMonth; m++) {

          const usage =
            customer.monthly &&
            customer.monthly[m]
              ? customer.monthly[m]
              : {};

          const item = {
            id: `${customer.domain}-m-${m}`,

            domain: customer.domain,

            name: customer.name,

            period: this.monthNames[m - 1],

            showCustomer: m === 1,

            isYearly: false,
          };

          /*
           * Bütün global kolonları dolaş.
           *
           * Müşteride type varsa:
           *     değer / 0
           *
           * Müşteride type yoksa:
           *     -
           */
          this.allTypes.forEach(type => {

            if (customerTypeKeys.has(type.key)) {

              item[type.key] =
                usage[type.key] !== undefined
                  ? usage[type.key]
                  : "0";

            } else {

              item[type.key] = "-";

            }

          });

          items.push(item);
        }

        /*
         * -----------------------------------------------------
         * YILLIK TOPLAM
         * -----------------------------------------------------
         */
        const yearly = customer.yearly || {};

        const yearlyItem = {
          id: `${customer.domain}-yearly`,

          domain: customer.domain,

          name: customer.name,

          period: "Yıllık Toplam",

          showCustomer: false,

          isYearly: true,
        };

        this.allTypes.forEach(type => {

          if (customerTypeKeys.has(type.key)) {

            yearlyItem[type.key] =
              yearly[type.key] !== undefined
                ? yearly[type.key]
                : "0";

          } else {

            yearlyItem[type.key] = "-";

          }

        });

        items.push(yearlyItem);
      });

      return items;
    },
  },

  methods: {

    /*
     * ---------------------------------------------------------
     * SATIR CLASS
     * ---------------------------------------------------------
     */
    rowClass(item) {

      if (!item) {
        return "";
      }

      return item.isYearly
        ? "yearly-row"
        : "";
    },

    /*
     * ---------------------------------------------------------
     * RAPORU GETİR
     * ---------------------------------------------------------
     */
    async getReport() {

      this.loading = true;

      this.error = null;

      try {

        const res = await this.$http.get(
          "/manage/used/events",
          {
            params: {
              year: this.selectedYear,
            },
          }
        );

        if (res.data && res.data.success) {

          this.reportData =
            Array.isArray(res.data.data)
              ? res.data.data
              : [];

        } else {

          this.error =
            (res.data && res.data.error)
              || "Bilinmeyen hata oluştu.";

          this.reportData = [];
        }

      } catch (err) {

        console.error(
          "Events kullanım raporu alınırken hata:",
          err
        );

        this.error =
          "Rapor alınırken bir hata oluştu.";

        this.reportData = [];

      } finally {

        this.loading = false;
      }
    },
  },

  mounted() {

    this.getReport();

  },
};
</script>

<style scoped lang="scss">

.report-wrapper {

  .filters {

    margin-bottom: 1rem;

    display: flex;

    align-items: center;

    gap: 1rem;

    label {
      font-weight: 600;
    }

    #year {
      max-width: 140px;
    }
  }

  .loading,
  .error,
  .no-data {

    margin-top: 1rem;

    font-weight: 600;
  }

  .error {

    color: #d33;
  }

  .report-result {

    margin-top: 1rem;

    .report-table {

      ::v-deep th,
      ::v-deep td {

        vertical-align: middle;
      }

      ::v-deep td.text-right {

        text-align: right;
      }

      ::v-deep tbody tr.yearly-row {

        font-weight: 700;

        background: #faf5d7 !important;
      }
    }
  }
}
</style>